import { reviews } from '@/mocks/homeData';

export default function Reviews() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full border border-background-300/60 text-foreground-500 text-xs font-medium font-label mb-4">
            Community Voices
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Trusted by Thousands<br />of Smart Shoppers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              className="rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-7 flex flex-col"
            >
              {/* Avatar + Name */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-sm font-bold text-primary-600">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-400">{review.handle}</p>
                </div>
              </div>

              {/* Review text */}
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Stars */}
              <div className="mt-4 flex items-center gap-0.5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-400 text-sm"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}